export default __webpack_public_path__ + "media/images/brighteon-social/about/bg_pattern-7a9356310219678528a6d879fda91feb.png";